/* vegas
----------------------------------------------- */
$('#slider').vegas({
	overlay: true,
	transition: 'blur',
	transitionDuration: 2000,
	delay: 10000,
	animationDuration: 20000,
	animation: 'kenburns',
	overlay: false,
	slides: responsiveImage,
});

/* header copy
----------------------------------------------- */
var gnavi = $('.header-wrapper').clone(true);
$('#gnavi').append(gnavi);

/* resize
----------------------------------------------- */
var resize_timer = false;
$(window).resize(function(){
	if(resize_timer !== false){
		clearTimeout(resize_timer);
	}
	resize_timer = setTimeout(function(){
		$('#slider').height( $(window).outerHeight() );
		fit_btn();
//		console.log('resized');
	}, 200);
});

/* smpleScroll by 101
----------------------------------------------- */
(function($) {
	$.fn.smpleScroll = function(options){
	
		var defaults = {
			speed	: 800,
			dis		: 15,//px
		};
		var conf = $.extend(defaults, options);

		//var vw = $(window).width();
		var oh = $(window).outerHeight();
		var resize_timer = false;
		var arr = [];
		var move = false;
		var current = -1;
		
		var $this = this;
		this.each(function(){
			var t = $(this).offset().top;
			var h = $(this).outerHeight();
			arr.push({top:t, btm:t+h, h:h});
		});

		$(window).on('load scroll', function(){
		    var y = $(this).scrollTop();
			if(!move){
				action(y);
			}
		});

		$('a.scroll-move').on('click', function(){
			var id = $(this).attr('href');
			var i = Number(id.replace('#', '', id));
			var pos = arr[i];
			scrollPos(pos.top);
			current = i;
			return false;
		});
		
		function action(y){
			for(let i=0; i<arr.length; i++){
				var pos = arr[i];
				if(y < pos.top + pos.h - conf.dis && y > pos.top + pos.h/2 + conf.dis){
					scrollPos(pos.top);
					current = i;
					break;
				}else if(y > pos.top + conf.dis && y < pos.top + pos.h/2 - conf.dis){
					scrollPos(pos.top+pos.h);
					current = i+1;
					break;
				}
				current = -1;
			}
		}

		function scrollPos(pos){
			move = true;
			//スクロール禁止(ios safariでコンテンツが浮く)
//			$('html *').css('overflow','hidden');
//			$(window).on('touchmove.noScroll', function(e){
//				e.preventDefault();
//			});
			$('html, body').stop().animate({scrollTop:pos}, conf.speed, function(){
				setTimeout(function(){
					move = false;
					//スクロール禁止解除
//					$('html *').css('overflow','visible');
//					$(window).off('.noScroll');
				}, 400);
			});
		}

		$(window).resize(function(){
			if(resize_timer !== false){
				clearTimeout(resize_timer);
			}
			resize_timer = setTimeout(function(){
//				console.log('resized in plugin');
				var resize_oh = $(window).outerHeight();
				if(oh !== resize_oh){
					arr = [];
					$this.each(function(){
						var t = $(this).offset().top;
						var h = $(this).outerHeight();
						arr.push({top:t, btm:t+h, h:h});
					});
					if(arr[current] && !move){
						var pos = arr[current];
						scrollPos(pos.top);
					}
					oh = resize_oh;
				}
			}, 200);
		});

		return(this);
	};
})(jQuery);

$('.scroll-block').smpleScroll({
	speed:800,
	dis:15
});

/* fix header
----------------------------------------------- */
$(window).on('scroll load', function(){
	var header_id = '#shopify-section-header';
	if($('#gnavi:visible').length>0){
		var gnaviH = $('#gnavi').outerHeight(true);
		var st = $(window).scrollTop();
		let y = $('#gnavi').offset().top + gnaviH;
		if (st >= y){
			$(header_id).addClass('fix');
		}else{
			$(header_id).removeClass('fix');
		}
	}else{
		if(!$(header_id).hasClass('fix')){
			$(header_id).addClass('fix');
		}
	}
});

/* fit bottom
----------------------------------------------- */
//$('.fit-h').css({height:window.innerHeight});
function fit_btn(){
	const vh = window.innerHeight;
	const wrap = $('.js-fit').closest('.scroll-block').height();
	const mb = wrap - vh;
	$('.js-fit').css({marginBottom:mb});
}
fit_btn();

/* scrollify
----------------------------------------------- */
/*
$('#MainContent>.shopify-section:not(:first)').each(function(){
	$(this).children().appendTo('.scroll-block:last');
});
$('#shopify-section-footer').appendTo('.scroll-block:last');
*/

/*
$.scrollify({
	section : ".scroll-block",
	scrollbars:"false",
	easing: "swing",
	scrollSpeed: 800,
	scrollbars:false,
	setHeights: false,
	overflowScroll: true,
//	interstitialSection: "#shopify-section-footer"
//	interstitialSection: "#news-area,#pos-about,#shopify-section-footer,.shopify-section"
//	interstitialSection: "#shopify-section-announcement-bar,#shopify-section-header,shopify-section-footer",
});

$('.scrollify-move').on('click', function(e){
	e.preventDefault();
	let href = $(this).attr('href');
	$.scrollify.move(href);
});
*/

/*
var scrollify_current;
$.scrollify({
	section:".scroll-block",
	scrollSpeed:800,
	setHeights:false,
//	scrollbars:false,
//	overflowScroll: true,
//	interstitialSection: "#noscroll",
	before:function(i,box){
		scrollify_current = i
//			$('.pagenation .active').removeClass('active');
//			$('.pagenation').find('a').eq(i).addClass('active'); 
	},        
	afterRender:function(){
//			var pagenation = '<ul class="pagenation">';
//			$('.box').each(function(i){
//				pagenation += '<li><a></a></li>';
//			});
//			pagenation += '</ul>';
//			$('body').append(pagenation);
//			$('.pagenation a').each(function(i){
//				$(this).on('click',function(){
//					$.scrollify.move(i);
//				});
//			});
//			$('.pagenation li:first-child').find('a').addClass('active');

		$('.scrollify-move').on('click', function(e){
			e.preventDefault();
			let href = $(this).attr('href');
			$.scrollify.move(href);
		});

	},
});
$(window).on('resize',function(){
	if(scrollify_current){
		var currentScrl = $('.scroll-block').eq(scrollify_current).offset().top;
		$(window).scrollTop(currentScrl);
	}
});
*/

/*
(function($){
jQuery(function($){
	var current;
	$.scrollify({
		section:".scroll-block",
		scrollSpeed:800,
		setHeights:false,
		scrollbars:false,
		overflowScroll: true,
		interstitialSection: "#noscroll",
		before:function(i,box){
			current = i
//			$('.pagenation .active').removeClass('active');
//			$('.pagenation').find('a').eq(i).addClass('active'); 
		},        
		afterRender:function(){
//			var pagenation = '<ul class="pagenation">';
//			$('.box').each(function(i){
//				pagenation += '<li><a></a></li>';
//			});
//			pagenation += '</ul>';
//			$('body').append(pagenation);
//			$('.pagenation a').each(function(i){
//				$(this).on('click',function(){
//					$.scrollify.move(i);
//				});
//			});
//			$('.pagenation li:first-child').find('a').addClass('active');

			$('.scrollify-move').on('click', function(e){
				e.preventDefault();
				let href = $(this).attr('href');
				$.scrollify.move(href);
			});

		},
	});
	$(window).on('resize',function(){
		if(current){
			var currentScrl = $('.scroll-block').eq(current).offset().top;
			$(window).scrollTop(currentScrl);
		}
	});
});
})(jQuery);
*/
